import React, { useState } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import Navbar from "../../../../globals/components/Navbar";

import DuplicateUsersTab from "./DuplicateUsersTab";
import DuplicateLawFirmsTab from "./DuplicateLawFirmsTab";
import DuplicatePGsTab from "./DuplicatePGsTab";
import MergeLogTab from "./MergeLogTab";

/**
 * Top-level page for the super-user-only "Duplicate Accounts" admin tool.
 * Renders four tabs:
 *   1. Portal Users      — Donal-Gross-style duplicates
 *   2. Law Firms         — Mariani-style duplicates
 *   3. Professional Guardians
 *   4. Merge Log         — full audit trail with per-row Undo
 */
const TABS = [
  { value: "users", label: "Portal Users" },
  { value: "law_firms", label: "Law Firms" },
  { value: "pgs", label: "Professional Guardians" },
  { value: "log", label: "Merge Log" },
];

const DuplicateAccountsHome = () => {
  const [tab, setTab] = useState("users");

  return (
    <>
      <Navbar />
      <Box sx={{ maxWidth: "100%", padding: 3 }}>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h4" sx={{ fontWeight: 800, color: "black" }}>
            Duplicate Accounts
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary", mt: 0.5 }}>
            Identify and merge duplicate accounts across portal users, law firms, and professional
            guardians. Every merge is recorded and can be undone within 30 days.
          </Typography>
        </Box>

        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
          <Tabs
            value={tab}
            onChange={(_, v) => setTab(v)}
            indicatorColor="primary"
            textColor="primary"
          >
            {TABS.map((t) => (
              <Tab key={t.value} value={t.value} label={t.label} />
            ))}
          </Tabs>
        </Box>

        {tab === "users" && <DuplicateUsersTab />}
        {tab === "law_firms" && <DuplicateLawFirmsTab />}
        {tab === "pgs" && <DuplicatePGsTab />}
        {tab === "log" && <MergeLogTab />}
      </Box>
    </>
  );
};

export default DuplicateAccountsHome;
